namespace $.$$ {
	export class $shm_hitalama_hovered extends $.$shm_hitalama_hovered {
		
		pointerenter( next?: any ) {
			this.hovered( true )
		}

		pointerleave( next?: any ) {
			this.hovered( false )
		}
		
	}
}
